import { validate } from './validators';

Object.defineProperty(window, '__env__', {
  value: window.__env__,
  writable: false,
  configurable: false,
});

Object.preventExtensions(window.__env__);

const _ENV_VARS = {
  REACT_APP_API_URL: import.meta.env.REACT_APP_API_URL,
  REACT_APP_ORIGIN_API: import.meta.env.REACT_APP_ORIGIN_API,

  REACT_APP_TRIMPLE_MAPS_API_KEY: import.meta.env.REACT_APP_TRIMPLE_MAPS_API_KEY,

  REACT_APP_BLOB_FILE_URL: import.meta.env.REACT_APP_BLOB_FILE_URL,
  REACT_APP_RATE_UPS_AUTH: import.meta.env.REACT_APP_RATE_UPS_AUTH,
  // REACT_APP_API_RATESHOP_API: import.meta.env.REACT_APP_API_RATESHOP_API,
  // REACT_APP_API_RATESHOP_API_USER_NAME: import.meta.env.REACT_APP_API_RATESHOP_API_USER_NAME,
  // REACT_APP_API_RATESHOP_API_USER_PASSWORD: import.meta.env.REACT_APP_API_RATESHOP_API_USER_PASSWORD,

  REACT_APP_SSO_SPI_FLOW: import.meta.env?.REACT_APP_SSO_SPI_FLOW,
  REACT_APP_NEW_DOMAIN_URL: import.meta.env?.REACT_APP_NEW_DOMAIN_URL,

  // If the environment variable is not defined,
  // the value will not be changed and
  // the process or import.meta.env will be undefined
  // REACT_APP_OIDC_AUTHORITY is optional for env
  REACT_APP_OIDC_AUTHORITY: import.meta.env?.REACT_APP_OIDC_AUTHORITY,
  REACT_APP_OIDC_CLIENT_ID: import.meta.env?.REACT_APP_OIDC_CLIENT_ID,

  REACT_APP_THEME: import.meta.env.REACT_APP_THEME,
  VERSION: import.meta.env.VERSION,
  REACT_APP_FEATURE_SPOT_QUOTE_COPY_ENABLED: import.meta.env.REACT_APP_FEATURE_SPOT_QUOTE_COPY_ENABLED,
  ...window.__env__,
};

console.log(`[VERSION]: ${_ENV_VARS.VERSION}`);

if (process.env.NODE_ENV === 'development') {
  console.log(_ENV_VARS);
}

export const ENV_VARS = validate(_ENV_VARS);
